class WhisperMultilingualService {
  constructor() {
    this.whisperServiceUrl = process.env.NODE_ENV === "production"
      ? "https://your-whisper-service.com"
      : "http://localhost:5000";
  }

  async transcribeAndTranslate(audioBlob, engine = "deepl", targetLang = "EN") {
    try {
      console.log('🚀 WhisperService: Starting transcription...', {
        blobSize: audioBlob.size,
        blobType: audioBlob.type,
        engine,
        targetLang,
        serviceUrl: this.whisperServiceUrl
      });

      // Validate engine parameter
      if (!['deepl', 'bhashini'].includes(engine)) {
        throw new Error(`Invalid engine: ${engine}. Use 'deepl' or 'bhashini'`);
      }

      const formData = new FormData();
      formData.append("audio", audioBlob);
      formData.append("engine", engine);
      formData.append("target_lang", targetLang);

      const response = await fetch(`${this.whisperServiceUrl}/api/transcribe`, {
        method: "POST",
        body: formData
      });

      console.log('📊 Response status:', response.status, response.statusText);

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        console.error('❌ API Error Response:', errorData);
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('✅ Transcription successful:', data);

      return {
        transcript: data.transcript || '',
        translation: data.translation || '',
        engine: data.engine || engine,
        status: data.status || 'success'
      };
    } catch (error) {
      console.error('❌ Whisper transcription failed:', error);
      throw error; // Re-throw to let the component handle it
    }
  }

  async getSupportedLanguages() {
    try {
      const response = await fetch(`${this.whisperServiceUrl}/api/languages`);
      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      console.error('Failed to fetch supported languages:', error);
    }

    // Fallback data
    return {
      deepl: {
        name: "DeepL",
        description: "English and international languages",
        languages: ["EN", "DE", "FR", "ES", "IT", "PT", "RU", "JA", "ZH"]
      },
      bhashini: {
        name: "Bhashini",
        description: "Indian languages",
        languages: ["hi", "ta", "te", "kn", "ml", "gu", "pa", "bn", "or", "as"]
      }
    };
  }

  async checkHealth() {
    try {
      const response = await fetch(`${this.whisperServiceUrl}/api/whisper/health`);
      if (response.ok) {
        const data = await response.json();
        return {
          healthy: true,
          ...data
        };
      }
      return { healthy: false, error: 'Service unavailable' };
    } catch (error) {
      console.error('Whisper service health check failed:', error);
      return { healthy: false, error: error.message };
    }
  }
}

export default new WhisperMultilingualService();